import '../../../Overview.css';
import './OverviewStatus.css';
import React, { useState } from 'react';
import { Collapse, Container } from 'reactstrap';
import { Row, Col } from 'reactstrap';
import SyncCards from './SyncCards';
import ConversionStatus from './Conversions';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faRandom } from '@fortawesome/free-solid-svg-icons';
import { shallowEqual, useSelector } from 'react-redux';
import ClientPlugins from './Plugins';
import hasPermission from '../../../../Shared/hasPermission';
import {
    getStatusBadgeText,
    getStatusBackgroundClass,
} from '../../../../Shared/StatusHelper';

const OverviewStatus = () => {
    // TODO: Make two wrapper components
    // so that this state change does not re-render the other half of the tree
    const [syncOpen, setSyncOpen] = useState(true);
    const [conversionOpen, setConversionOpen] = useState(true);
    const [isPluginsOpen, setPluginsOpen] = useState(true);
    const practiceStatus = useSelector(
        (state) => ({
            hasConversion: state.practice.practice?.hasConversion,
            isTestPractice: state.practice.practice?.isTestPractice,
            isDormant: state.practice.practice?.isDormant,
            ignoreStatus: state.practice.practice?.ignoreStatus,
            isMuted: state.practice.practice?.isMuted,
            partiallyActive: state.practice.practice?.partiallyActive,
            hasHeartbeatError: state.practice.practice?.hasHeartbeatError,
            staleValue: state.practice.practice?.staleValue,
            hasExtractionError: state.practice.practice?.extractionError,
            hasStagingLoadError: state.practice.practice?.stagingLoadError,
            hasIntermediateLoadError:
                state.practice.practice?.intermediateLoadError,
            hasConversionPrepError:
                state.practice.practice?.conversionPrepError,
            hasLeadsGenerationError:
                state.practice.practice?.leadsGenerationError,
        }),
        shallowEqual
    );

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );

    const canSeePlugins = hasPermission(['ClientPluginsView'], permissions);

    return (
        <Container className="sc-glass sc-shadow sc-rounded mb-4">
            <Row className="pt-3 px-3 text-light d-flex text-center align-items-center justify-content-start">
                <h2>Status</h2>
                <div className="mr-2"></div>
                <span
                    className={classNames(
                        'text-20 px-4 py-1 sc-rounded',
                        getStatusBackgroundClass(practiceStatus)
                    )}>
                    {getStatusBadgeText(practiceStatus)}
                    {practiceStatus.hasConversion && (
                        <span>
                            &emsp;
                            <FontAwesomeIcon
                                size="lg"
                                title="This practice has a conversion offering"
                                icon={faRandom}
                            />
                        </span>
                    )}
                </span>
            </Row>
            <Row className="text-light my-2">
                {/* Sync Cards */}
                <Col xs="12" className="px-3 border-top">
                    <h4
                        className="mt-2 d-flex justify-content-between hoverable"
                        onClick={() => setSyncOpen(!syncOpen)}>
                        Sync
                        <span className="hoverable">
                            <FontAwesomeIcon
                                className={classNames('rotate-animated', {
                                    rotated: !syncOpen,
                                })}
                                icon={faAngleDown}
                                size="lg"
                            />
                            &nbsp;&nbsp;
                        </span>
                    </h4>
                    <Collapse isOpen={syncOpen}>
                        <SyncCards />
                    </Collapse>
                </Col>
                {/* End Sync Cards */}
            </Row>
            {canSeePlugins && (
                <Row className="text-light my-2">
                    <Col xs="12" className="px-3 border-top">
                        <h4
                            className="mt-2 d-flex justify-content-between hoverable"
                            onClick={() => setPluginsOpen(!isPluginsOpen)}>
                            Client Plugins
                            <span className="hoverable">
                                <FontAwesomeIcon
                                    className={classNames('rotate-animated', {
                                        rotated: !isPluginsOpen,
                                    })}
                                    icon={faAngleDown}
                                    size="lg"
                                />
                                &nbsp;&nbsp;
                            </span>
                        </h4>
                        <Collapse isOpen={isPluginsOpen}>
                            <ClientPlugins />
                        </Collapse>
                    </Col>
                </Row>
            )}

            <Row className="text-light my-2">
                {/* Conversions */}
                {practiceStatus.hasConversion && (
                    <Col xs="12" className="px-3 border-top">
                        <h4
                            className="mt-2 d-flex justify-content-between hoverable"
                            onClick={() => setConversionOpen(!conversionOpen)}>
                            Conversion
                            <span className="hoverable">
                                <FontAwesomeIcon
                                    className={classNames('rotate-animated', {
                                        rotated: !conversionOpen,
                                    })}
                                    icon={faAngleDown}
                                    size="lg"
                                />
                                &nbsp;&nbsp;
                            </span>
                        </h4>
                        <Collapse isOpen={conversionOpen}>
                            <ConversionStatus />
                        </Collapse>
                    </Col>
                )}
                {/* End Conversions */}
            </Row>
        </Container>
    );
};

export default React.memo(OverviewStatus);
